var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("domain-workspace-toolbar", {
                attrs: {
                  backLink: _vm.backLink,
                  subtitle:
                    _vm.getFriendlyLoadJobTypeName(_vm.selectedLoadJob.type) +
                    " Job",
                  subsubtitle: "Operations"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "mb-4" },
        [
          _c(
            "v-card-title",
            [
              _c("div", { staticClass: "text-header-2 ml-4 mb-2" }, [
                _vm._v(_vm._s(_vm.selectedLoadJob.label))
              ]),
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c("v-expansion-panel-header", [
                        _vm._v(
                          "Filters " + _vm._s(_vm.queryParamFormattedFilter)
                        )
                      ]),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-container",
                            [
                              _vm._l(_vm.filter, function(
                                filterItem,
                                filterIndex
                              ) {
                                return _c(
                                  "v-row",
                                  { key: filterIndex },
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-combobox", {
                                          attrs: {
                                            label: "Key",
                                            "single-line": "",
                                            "hide-details": "",
                                            items: _vm.commonFilters
                                          },
                                          model: {
                                            value: filterItem.key,
                                            callback: function($$v) {
                                              _vm.$set(filterItem, "key", $$v)
                                            },
                                            expression: "filterItem.key"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Value",
                                            "single-line": "",
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: filterItem.value,
                                            callback: function($$v) {
                                              _vm.$set(filterItem, "value", $$v)
                                            },
                                            expression: "filterItem.value"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { staticClass: "col-1" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mt-6",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.filter.pop()
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [_vm._v("mdi-delete")])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.addFilter(_vm.filter)
                                            }
                                          }
                                        },
                                        [_vm._v("Add Filter")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "10" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { block: "", color: "primary" },
                              on: { click: _vm.getDomoSearchResults }
                            },
                            [_vm._v("Search")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                disabled:
                                  !_vm.filter ||
                                  Object.keys(_vm.filter).length < 1
                              },
                              on: { click: _vm.copyFilterToClipboard }
                            },
                            [_vm._v("Copy Filter")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.domoTable.headers,
                  loading:
                    _vm.isDomoLoading ||
                    _vm.isLoadJobLoading ||
                    _vm.isDomainLoading,
                  items: _vm.domoTable.data,
                  "items-per-page": _vm.domoTable.itemsPerPage,
                  page: _vm.domoTable.page,
                  "hide-default-footer": "",
                  dense: "",
                  "item-key": "uuid"
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.domoTable, "page", $event)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.uuid",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary", dark: "", icon: "" },
                            on: {
                              click: function($event) {
                                return _vm.showDomoDetailDialog(item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-eye")])],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "item.updatedAt",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatDbDate(item.updatedAt)) + " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c(
                "div",
                { staticClass: "text-center pt-2" },
                [
                  _c("v-pagination", {
                    attrs: { length: _vm.domoTable.pageCount },
                    on: { input: _vm.getNextPage },
                    model: {
                      value: _vm.domoTable.page,
                      callback: function($$v) {
                        _vm.$set(_vm.domoTable, "page", $$v)
                      },
                      expression: "domoTable.page"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "retain-focus": false, scrollable: "" },
          model: {
            value: _vm.domoDetailsDialog,
            callback: function($$v) {
              _vm.domoDetailsDialog = $$v
            },
            expression: "domoDetailsDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("span", { staticClass: "text-h5 mr-4" }, [
                    _vm._v(
                      "View " + _vm._s(_vm.currentDomo.entityType) + " DOMO"
                    )
                  ]),
                  _c("v-text-field", {
                    attrs: { label: "UUID", readonly: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function() {
                          return [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", dark: "", icon: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.clipyboardCopyWithNotification(
                                      _vm.currentDomo.uuid || ""
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("mdi-content-copy")])],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.currentDomo.uuid,
                      callback: function($$v) {
                        _vm.$set(_vm.currentDomo, "uuid", $$v)
                      },
                      expression: "currentDomo.uuid"
                    }
                  }),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.domoDetailsDialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close-circle")])],
                    1
                  )
                ],
                1
              ),
              _c("v-card-text", [
                _c(
                  "p",
                  [
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            _vm.clipyboardCopyWithNotification(
                              _vm.jsonPretty(_vm.currentDomo)
                            )
                          }
                        }
                      },
                      [
                        _c("v-icon", [_vm._v("mdi-content-copy")]),
                        _vm._v(" Copy DOMO")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("pre", [
                  _vm._v(
                    _vm._s(_vm.jsonPretty(_vm.currentDomo)) +
                      "\n                "
                  )
                ])
              ]),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.domoDetailsDialog = false
                        }
                      }
                    },
                    [_vm._v(" Close ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("domain-dialog", { ref: "domainDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }